import React from 'react'
import PropTypes from 'prop-types';

const ErrorBanner = ({title, message, minHeight = 400,...props}) => {
    if (!title) title = TB.trans(`api.server_error.title`);
    if (!message) message = TB.trans(`api.server_error.message`, {code: 500});

    let titleLines = title;
    if (TB.isString(titleLines)) {
        titleLines = [titleLines];
    }

    let messageLines = message;
    if (TB.isString(messageLines)) {
        messageLines = messageLines.split('.  ');
    }
    return (
        <div className="feedback-banner"
             style={{color:'rgba(50, 60, 71, 0.4)', minHeight}}>

            <i className='fa fa-exclamation-circle' style={{fontSize:'35px'}}/>

            <p className="mt-3 text-center" style={{fontSize:'18px', marginBottom: 0}}>
                {titleLines.map((line,i) => (
                    <span key={`titleLine${i}`}>{line}<br/></span>
                ))}
            </p>

            <hr style={{height: 1, width: 200}}/>

            {TB.isFunction(props.onRetry) && (
                <button type="button"
                        className="btn px-4 py-2"
                        style={styles.errorButton}
                        onClick={() => props.onRetry()}>
                    <i className="fa fa-redo-alt mr-3"/>
                    {props.retryText || 'Retry'}
                </button>
            )}

            <p className="mt-3 text-center" style={{fontSize:'14px'}}>
                {messageLines.map((line,i) => (
                    <span key={`messageLine${i}`}>{line}<br/></span>
                ))}
            </p>
        </div>
    );
};


const styles = {
    errorButton: {
        alignSelf: 'center',
        textAlign: 'center',
        border: '1px solid rgba(50, 60, 71, 0.4)',
        boxSizing: 'border-box',
        fontWeight: 600,
        fontSize: '13px',
        lineHeight: '19px',
        letterSpacing: '0.01em',
        color: 'rgba(50, 60, 71, 0.4)',
    },
};

ErrorBanner.propTypes = {
    title: PropTypes.any,
    message: PropTypes.any,
    minHeight: PropTypes.any,
    retryText: PropTypes.any,
    onRetry: PropTypes.any,
};

export default ErrorBanner;

